import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import styled from "styled-components";

const Holder = styled.div`
  display: block;
  background-color: #d6c88b;
  position: fixed;
  z-index: 500;
  pointer-events: none;
  inset: 0;
  padding: 16px;

  @media (${(props) => props.theme.breakpoints.md}) {
    display: none;
  }
`;

const Menu = styled.div`
  height: 100%;
  grid-column: 2/3;
  display: flex;
  flex-direction: column;
  padding-top: 128px;

  h2 {
    font-size: 19px !important;
    font-weight: 500;
    margin: 0 0 25px 0;
  }

  a {
    width: fit-content;
    pointer-events: auto;
    text-decoration: none;
    font-size: 22px !important;
    font-weight: 300;
    line-height: 1.2;
  }
  > :first-child {
    margin-top: 0;
  }
  > :last-child {
    margin-bottom: 0;
  }
`;

const BottomLinks = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;

  a {
    font-weight: 500;
    font-size: 19px !important;
  }
`;

const MobileNav = ({ setShowMobileNav }) => {
  const data = useStaticQuery(graphql`
    query {
      prismicHomepage {
        data {
          projects {
            project {
              id
              document {
                ... on PrismicProject {
                  id
                  tags
                  uid
                  data {
                    title {
                      text
                    }
                    preview_assets {
                      image {
                        gatsbyImageData
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const projects = data.prismicHomepage.data.projects;

  const projectsMapped = projects.map((project) => ({
    title: project.project.document.data.title.text,
    uid: `/project/${project.project.document.uid}`,
  }));
  return (
    <Holder>
      <Menu>
        <h2>Projects</h2>
        {projectsMapped.map(({ uid, title }, index) => {
          return (
            <Link key={index} to={uid} onClick={() => setShowMobileNav(false)}>
              {title}
            </Link>
          );
        })}
        <BottomLinks>
          <Link to="/about" onClick={() => setShowMobileNav(false)}>
            About
          </Link>
          <Link
            href="https://www.instagram.com/studiolibro"
            target="_blank"
            onClick={() => setShowMobileNav(false)}
          >
            Instagram
          </Link>
        </BottomLinks>
      </Menu>
    </Holder>
  );
};

export default MobileNav;

